import { render, staticRenderFns } from "./jobdetails.vue?vue&type=template&id=3911fd2a&scoped=true&"
import script from "./jobdetails.vue?vue&type=script&lang=js&"
export * from "./jobdetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=3911fd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911fd2a",
  null
  
)

export default component.exports